import { jwtDecode } from "jwt-decode";

import { UserStatus } from "models/status/status";
import { TokenDecoded } from "models/login/login";
import { getStorage } from "./storage";

const webStorage = getStorage();

export function getTabToken() {
  return webStorage.getItem("token");
}

export function setTabToken(token: string) {
  webStorage.setItem("token", token);
}

export function getCompanyName() {
  return webStorage.getItem("companyName");
}

export function setCompanyName(token: string) {
  webStorage.setItem("companyName", token);
}

export function clearCompanyName() {
  webStorage.removeItem("companyName");
}

export function clearTabToken() {
  webStorage.removeItem("token");
}

export function getWorkingTabCustomer() {
  return webStorage.getItem("working_customer");
}

export function setWorkingTabCustomer(customerId: string) {
  webStorage.setItem("working_customer", customerId);
}

export function clearWorkingTabCustomer() {
  webStorage.removeItem("working_customer");
}

export function updateBrowserStatus(user: UserStatus) {
  const sum = user.unhandledUploads + user.unreadThreads;

  if (sum > 0) {
    document.title = "(" + sum + ") MittKontor";
  } else {
    document.title = "MittKontor";
  }
}

export function hasAccessToInvoiceReport() {
  if (!webStorage.getItem("token") || webStorage.token === "") {
    return false;
  }

  const tokenDecoded = jwtDecode<TokenDecoded>(webStorage.token);
  return tokenDecoded.hasAccessToInvoiceReport === "True";
}

export function isInternalUser() {
  if (!webStorage.getItem("token") || webStorage.token === "") {
    return false;
  }

  const tokenDecoded = jwtDecode<TokenDecoded>(webStorage.token);
  return !tokenDecoded.id.startsWith("External");
}

export function logoutUser() {
    clearTabToken();
}
